import React from 'react';
import { Redirect } from 'react-router-dom';

export class RedirectMonitoringPodKepalaKurirContainerSnowflake extends React.Component<any, any> {

  render() {
    return (<Redirect to={'/admin/monitoring-pod-sf-palkur'}/>);
  }
}
